import { createAtomObserver } from '@exodus/atoms'

const announcementsPlugin = ({
  announcements,
  visibleAnnouncementsAtom,
  port,
  allAnnouncementsAtom,
}) => {
  const observers = [
    createAtomObserver({ atom: visibleAnnouncementsAtom, port, event: 'visibleAnnouncements' }),
    createAtomObserver({ atom: allAnnouncementsAtom, port, event: 'allAnnouncements' }),
  ]

  const onStart = () => {
    observers.forEach((observer) => observer.register())
  }

  const onLoad = async () => {
    observers.forEach((observer) => observer.start())
  }

  const onUnlock = () => {
    announcements.load()
  }

  const onStop = () => {
    observers.forEach((observer) => observer.unregister())
  }

  return { onStart, onLoad, onUnlock, onStop }
}

const announcementsLifecyclePluginDefinition = {
  id: 'announcementsLifecyclePlugin',
  type: 'plugin',
  factory: announcementsPlugin,
  dependencies: ['announcements', 'port', 'visibleAnnouncementsAtom', 'allAnnouncementsAtom'],
  public: true,
}

export default announcementsLifecyclePluginDefinition
